export default __webpack_public_path__ + "static/media/nutritionGuideScreenshot1.7ae4b26b.png";